const
  NAME                 = 'buttonDisplacement',
  VERSION              = '1.0.0',
  JQUERY_NO_CONFLICT   = $.fn[NAME]
;

const _window$ = $(window);

class ButtonDisplacement {
  constructor(element$, options) {
    this._element$ = element$;
    this._options  = options;
    _window$.on('scroll', this.onScroll.bind(this));
    this._element$.on('click', this.onClick.bind(this));
  }

  onScroll(/*event*/) {
    let parent    = this._element$.parents('.voc-live-scribble');
    let topHeight = parent.offset().top;
    if ( _window$.scrollTop() >= _window$.height() &&
         _window$.scrollTop() >= topHeight &&
         _window$.scrollTop() <= ( parent.outerHeight() ) ) {
      this._element$.addClass('_fixed');
    }else{
      this._element$.removeClass('_fixed');
    }
  }

  onClick(/*event*/) {
    $('html, body').animate({scrollTop:0}, '500');
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new ButtonDisplacement($(this), options);
    });
  }
}

$.fn[NAME]             = ButtonDisplacement._jQueryInterface;
$.fn[NAME].Constructor = ButtonDisplacement;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return ButtonDisplacement._jQueryInterface;
};

export default ButtonDisplacement;



// WEBPACK FOOTER //
// ./src/plugins/button-displacement.js